import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const premiumApi = {
  getPurchasePlans() {
    return http.get(API_URLS.MEMBERSHIP_PURCHASE_PLANS, {});
  },
  buyMembershipPurchase(query) {
    return http.post(API_URLS.MEMBERSHIP_PURCHASE, {query});
  },
  getVipProfile(query = {}) {
    return http.get(API_URLS.VIP_PROFILE, query);
  },
  getVipFeeConfig(query) {
    return http.get(API_URLS.VIP_FEE_CONFIG, {query});
  },
};
